import {botstrapDeliveryAndOrder, getLastDelivery, getNextDelivery} from "../actions/delivery.js";
import {clearClaim, downloadHistoryPdf} from "../actions/history.js";
import {displaySeasonLinesMessage, impersonateUser, stopImpersonating } from "../../common/actions/authentication.js";
import {getBoughtProducts, getCampaignProducts, getNewProducts} from "../actions/productLists.js";
import {getOrderFeeLimits, getOrderVolumeDiscounts, moveUnconfirmedLinesToNextOrder, setActiveOrder } from "../actions/order.js";
import {setDropDown, setModal} from "../../common/actions/modal";

import DashboardPage from "../components/dashboard/dashboardPage.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../common/util/reselect.js";
import {createLocalization} from "../../common/util/localization.jsx";
import {getCustomerInfo} from "../actions/customer.js";
import {scssVariables} from "../../common/util/config.jsx";
import {submitOrder} from "../actions/order.js";

const mapStateToProps = () => {
    return (state) => ({
        deviceType: state.view.deviceType,
        localization: createLocalization(state),
        customer: state.customer,
        delivery: state.delivery,
        token: state.authentication.token,
        signedInAs: state.authentication.signedInAs,
        productLists: state.productLists,
        activeOrder: state.order.active,
        lastDelivery: state.delivery.lastDelivery,
        lastDeliveryProductList: state.delivery.lastDelivery.orderLines,
        nextDelivery: state.delivery.nextDelivery,
        nextDeliveryProductList: state.delivery.nextDelivery.unConfirmedOrderLines,
        productImage: state.productImage,
        isAdmin: state.authentication.isAdmin,
        isBlockedCustomer:  state.authentication.isBlockedCustomer,
        isImpersonated: state.authentication.isImpersonated,
        orderFeeLimits: state.order.orderFeeLimits,
        orderVolumeDiscounts: state.order.orderVolumeDiscounts,
        deliveryDates: state.delivery.dates.deliveryDates || [],
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        width: state.view.innerWidth,
        newSeasonDistrDates : state.authentication.newSeasonDistrDates || [],
        seasonMessageConfirmed : state.authentication.seasonMessageConfirmed,
    });
};

const mapDispatchToProps = {
    botstrapDeliveryAndOrder,
    getBoughtProducts,
    getCampaignProducts,
    getCustomerInfo,
    getLastDelivery,
    getNewProducts,
    getNextDelivery,
    impersonateUser,
    setActiveOrder,
    setDropDown,
    setModal,
    stopImpersonating,
    submitOrder,
    downloadHistoryPdf,
    clearClaim,
    getOrderFeeLimits,
    getOrderVolumeDiscounts,
    moveUnconfirmedLinesToNextOrder,
    displaySeasonLinesMessage,
};

const mySubmitOrder = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    submitOrder: mySubmitOrder(() => dispatchProps.submitOrder(stateProps.activeOrder)),
});


export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DashboardPage);